import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { sendEventClick } from 'src/api/tracker';

import SectionContainer from 'src/containers/SectionContainer';
import BoxPopularCategories from 'src/components/BoxPopularCategories';
import Pagination from 'src/components/Pagination/PaginationWrapper';

const PopularCategoriesContainer = ({ tiles }) => (
  <SectionContainer
    dataTestName="section-seo-categories"
    title="Najpopularniejsze kategorie"
  >
    <Pagination>
      {tiles.map(
        ({ absoluteUrl, badge, name, iconName, offersCount }, index) => (
          <BoxPopularCategories
            key={`popular-category-${iconName}`}
            badge={badge || ''}
            counter={offersCount}
            iconName={iconName}
            link={absoluteUrl}
            title={name}
            onClick={() => {
              sendEventClick('seobox_category', index);
            }}
          />
        )
      )}
    </Pagination>
  </SectionContainer>
);

PopularCategoriesContainer.propTypes = {
  tiles: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProperties = ({ seoReducer }) => ({
  tiles: seoReducer.categories,
});

export default connect(mapStateToProperties)(PopularCategoriesContainer);
